import { AppIdentifier, appIdentifierToActionPrefixMap } from "../../types";
import { ACTION_APP_LOADED, ACTION_SET_JWT, ACTION_SET_MODAL_STATE } from "./constants";

export interface IFiatAccountLinkState {
  jwt: string;
  isAppLoaded: boolean;
  isAppActive: boolean;
}

export interface IFiatAccountLinkAction {
  type: string;
  jwt?: string;
  isAppActive?: boolean;
  isAppLoaded?: boolean;
}

const INITIAL_STATE: IFiatAccountLinkState = {
  jwt: "",
  isAppActive: false,
  isAppLoaded: false
}

const applySetIsAppActive = (state: IFiatAccountLinkState, action: IFiatAccountLinkAction): IFiatAccountLinkState => {
  return {
    ...state,
    isAppActive: !!action.isAppActive,
  }
}

const applySetSendJWTToApp = (state: IFiatAccountLinkState, action: IFiatAccountLinkAction): IFiatAccountLinkState => {
  return {
    ...state,
    isAppLoaded: !!action.isAppLoaded,
  }
}

const applySetJWT = (state: IFiatAccountLinkState, action: IFiatAccountLinkAction): IFiatAccountLinkState => {
  return {
    ...state,
    jwt: action.jwt as string,
  }
}

const reducerMap: {
  [actionType: string]: (state: IFiatAccountLinkState, action: IFiatAccountLinkAction) => IFiatAccountLinkState
} = {
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.FIAT_ACCOUNT_LINK)}${ACTION_SET_JWT}`]: applySetJWT,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.FIAT_ACCOUNT_LINK)}${ACTION_SET_MODAL_STATE}`]: applySetIsAppActive,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.FIAT_ACCOUNT_LINK)}${ACTION_APP_LOADED}`]: applySetSendJWTToApp,
};

const fiatAccountLinkReducer = (state = INITIAL_STATE, action: IFiatAccountLinkAction) => {
  if (!!action.type && !!reducerMap[action.type]) {
    return reducerMap[action.type](state, action);
  } else {
    return state;
  }
}

export default fiatAccountLinkReducer;